module.exports = __webpack_public_path__ + "img/shed.72fedd5d.jpg";